// @ts-nocheck
/* eslint-disable */
export const logoutIcon = {
  data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33331 15H4.99998V16.6667H15V3.33335H4.99998V5.00002H3.33331V2.50002C3.33331 2.03979 3.70641 1.66669 4.16665 1.66669H15.8333C16.2936 1.66669 16.6666 2.03979 16.6666 2.50002V17.5C16.6666 17.9603 16.2936 18.3334 15.8333 18.3334H4.16665C3.70641 18.3334 3.33331 17.9603 3.33331 17.5V15ZM4.99998 9.16669H10.8333V10.8334H4.99998V13.3334L0.833313 10L4.99998 6.66669V9.16669Z" fill="currentColor"/></svg>`,
  name: 'logout' as const,
};
